import styled from 'styled-components';

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  height: 20px;
  padding-right: 1.5em;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;

  & svg {
    transform: scale(1.1);
  }

  &:hover svg g {
    fill: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  }

  &:focus svg g {
    fill: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  }
`;
